<script setup lang="ts">
import { recordPageList } from '@mp/api/sdpMessage/MessageV2Controller.js'
import Item from './Item.vue'
import { reactive, ref } from 'vue'
import WujieVue from 'wujie-vue3'

const { bus } = WujieVue

const finished = ref<boolean>(false)
const list = ref<APISdpMessage.MessageRecordDto[]>([])

const params = reactive<{
  queryType: APISdpMessage.QueryCursorMessageRecordRequest['queryType']
  targetAppId: APISdpMessage.QueryCursorMessageRecordRequest['targetAppId']
  messageType: string
}>({
  queryType: 'ALL',
  targetAppId: 'WEB_B',
  messageType: 'system_notification',
})

const pager = reactive<{
  pageNum: number
  pageSize: number
  total: number
}>({
  pageNum: 1,
  pageSize: 20,
  total: 0,
})

async function handleGetDatas(reset = false) {
  if (reset)
    pager.pageNum = 1

  const { series, totalCount } = await recordPageList({
    pageNum: pager.pageNum,
    pageSize: pager.pageSize,
    ...params,
  })

  if (!totalCount)
    return finished.value = true

  pager.pageNum += 1
  if (reset)
    list.value = []

  pager.total = totalCount || 0
  list.value.push(...(series || []))

  if (totalCount && (list.value?.length >= totalCount))
    finished.value = true
}

function handleOnload() {
  handleGetDatas()
}

bus.$on('notice:open', () => {
})
bus.$on('notice:detail:close', () => {
  handleGetDatas(true)
})
</script>

<template>
  <el-empty v-if="!list?.length" description="暂无数据" :image-size="100" />
  <ul v-infinite-scroll="handleOnload" :infinite-scroll-disabled="finished">
    <div v-for="item in list" :key="item.messageId">
      <Item :data="item" />
    </div>
  </ul>
</template>
